import React, { useEffect, useRef } from 'react';
import Input from '../VaccinationDetailsWrapper/Components/InputForm';

const ThankYouVaccinationDetails = ({ t }) => {
  const thank_you_ref = useRef();

  useEffect(() => {
    thank_you_ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, [])

  const _handleDoneClick = () => {
    window.close();
  }

  return (
    <div ref={thank_you_ref} className="express-interest-question express-interest-first-question align-item-center">
      <div>
        <p className="margin-bottom-none">
          {t("VACC_DETAILS_THANK_YOU_COMPONENT_TEXT")}
        </p>
      </div>
      <div className="express-interest-modal-buttons">
        <Input
          addClassInput="express-interest-modal-button-yes express-interest-modal-button-padding"
          type="button"
          value={t("EOI_DONE")}
          onClick={_handleDoneClick}
        />
      </div>
    </div>
  );
};

export default ThankYouVaccinationDetails;